import React from 'react';

import { AddressProvider } from '@app/models/users';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { DaDataAutocomplete } from './components/DadataAutocomplete';
import { GoogleAutocomplete } from './components/GoogleAutocomplete';
import { IFieldProps } from './interfaces';

export const AddressAutocomplete: React.FC<IFieldProps> = ({
  disabled = false,
  defaultOpen = true,
  label,
  name,
  wrapperCol = { span: 24 },
  required = true,
  ...props
}) => {
  const lang = useLocalSelector((state) => state.currentSession.data?.scope?.settings?.address_provider || 'dadata');

  if (lang === AddressProvider.Dadata) {
    return (
      <DaDataAutocomplete
        {...props}
        disabled={disabled}
        defaultOpen={defaultOpen}
        label={label}
        name={name}
        wrapperCol={wrapperCol}
        required={required}
      />
    );
  }

  return (
    <GoogleAutocomplete
      {...props}
      disabled={disabled}
      defaultOpen={defaultOpen}
      label={label}
      name={name}
      wrapperCol={wrapperCol}
      required={required}
    />
  );
};
